exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unplaced_docket_reference, .unplaced_docket_name, .unplaced_docket_operation, .unplaced_docket_date{\r\n    padding-left: 5px !important;\r\n    padding-right: 5px !important;\r\n}\r\n\r\n.unplaced_docket_operation .mat-sort-header-container .mat-sort-header-button {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.unplaced_docket_reference{\r\n    width: 15%;\r\n    cursor: pointer;\r\n}\r\n\r\n.unplaced_docket_name{\r\n    width: 40%;\r\n    cursor: pointer;\r\n}\r\n\r\n.unplaced_docket_operation{\r\n    width: 15%;\r\n    /*text-align: center !important;*/\r\n}\r\n\r\n.unplaced_docket_date{\r\n    width: 30%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/location-docket.component.css
// module id = 480
// module chunks = 0